const KEY = 'TASKS_FRAMEWORK_RESOLVER_COMPLETED_TASKS';

export const getTasksCompletedThisSession = () => {
  const completedTasks = sessionStorage.getItem(KEY);

  if (completedTasks) {
    let parsed: string[];

    try {
      parsed = JSON.parse(completedTasks);
    } catch (error) {
      sessionStorage.removeItem(KEY);
      parsed = [];
    }

    return parsed;
  }

  return [];
};

export const markTaskAsCompleteForSession = (id: string) => {
  const completedTasks = getTasksCompletedThisSession();

  completedTasks.push(id);

  sessionStorage.setItem(KEY, JSON.stringify(completedTasks));
};
